
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 16"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#000","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M3.96 12.05H1V1h17.04v2.95"}}),_c('path',{attrs:{"d":"M3.96 3.95H21V15H3.96z"}})])])
          )
        }
      }
    